"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InvalidParamError_1 = __importDefault(require("../errors/InvalidParamError"));
function isValidFunction(fn) {
    if (!fn) {
        return false;
    }
    if (typeof fn !== 'function') {
        throw new InvalidParamError_1.default('method', '', 'must be a function');
    }
    return true;
}
exports.default = isValidFunction;
